export default class stringHelper {
    static convertNumberOrUndefinedToString(numberToConvert: number | undefined) {
        return numberToConvert != undefined ? numberToConvert.toString() : "";
    }
}



// WEBPACK FOOTER //
// ./src/Helper/stringHelper.ts